<template lang="html">

    <div class="cover-popup row-center -rgpd" v-if="rgpdtext && show">

        <div class="popup">

            <div class="text" v-html="rgpdtext"></div>

            <p>
                Puedes consultar información adicional y detallada sobre Protección de Datos: <a @click="hide">Pinchando aquí</a>
            </p>

            <div class="contenedor-botones row-center">
                <a class="btn" @click="aceptar" :loading="loading">Consiento, acceder</a>
                <a class="btn skull" @click="logout">Rechazar</a>
            </div>

        </div>

    </div>

</template>

<script lang="js">

    import { mapActions,mapGetters } from 'vuex';
    import router from '@/router';

    export default {
        name: 'popup-rgpd',
        props: ['texto','show'],
        data(){
            return{
                loading : false,
            }
        },
        computed:{
            ...mapGetters({
                rgpdtext : 'gettextRGPD'
            })
        },
        methods: {
            ...mapActions(['requestRGPD', 'requestLogout', 'acceptRGPD']),
            hide(){
                this.$emit('hide');
            },
            logout() {
                this.requestLogout().then(() => {
                    router.push({ name: 'login' })
                })
            },
            aceptar() {
                this.loading = true;
                this.acceptRGPD().then(r => {
                    if (r) {
                        router.push({ name: 'home' })
                        this.loading = false;
                    }
                })
            }
        }

    }
</script>

<style scoped lang="scss">

    .btn{
        margin: 0 5px;
    }

    p a{
        text-decoration: underline;
        display: inline-block;
        margin-top: 5px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-rgpd.vue